// extracted by mini-css-extract-plugin
module.exports = {"background":"Loader_background__I_8E_","loader":"Loader_loader__EUqVj","loaderRing":"Loader_loaderRing__xVdLD"};